import { data } from "react-router-dom";
import assets from "../../assets";
import { useSingleton } from "../../hooks/use-singleton";

export const ProfileHeader = () => {
  const { mail, user } = useSingleton();
  console.log(user, "usersingleton");
  const { board, role, school } = user?.data || {};
  return (
    <section className="settings-section">
      <div className="section-header">
        <h3>Profile</h3>
        <p>Manage your personal information</p>
      </div>
      <div className="settings-card profile-body">
        <section className="user-info">
          <img src={assets.ic_profile_chat} alt="profile" className="avatar" />
        </section>

        <section className="details">
          <div className="input-group">
            <label>Name</label>
            <input value={user?.data?.name} readOnly />
          </div>
          <div className="input-group">
            <label>Email</label>
            <input value={mail} readOnly />
          </div>
        </section>
      </div>
    </section>
  );
};
